import { FC } from 'react';
import { useNavigate } from 'react-router';
import { ROUTES } from '../../../constants/RouteNameMapping';
import { PermissionKey } from '../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../services/PermissionService';
import { toURLFriendlyStringWithDashes } from '../../../util/url-utils';
import { CompanySearch } from '../../CompanySearch/CompanySearch';
import { CompanySearchResponseWithRealId } from '../../../schemas/CompanySearchResponse.schema';

const companySearchSx = {
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '100%',
  minWidth: '14rem',
};

export const HeaderSearch: FC = () => {
  const navigate = useNavigate();
  const showPortcoOnly = !PermissionService.get().hasPermission(PermissionKey.canViewDeal);

  const redirectToCompanySummary = (company: CompanySearchResponseWithRealId) => {
    const { name } = company.fields;
    navigate(`${ROUTES.COMPANY_PROFILES}/${toURLFriendlyStringWithDashes(name)}-${company.id}`);
  };

  return (
    <CompanySearch
      onChange={redirectToCompanySummary}
      disablePortal={false}
      showPortcoOnly={showPortcoOnly}
      sx={{ ...companySearchSx, maxWidth: '35rem' }}
      fullWidth
    />
  );
};
